import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BydGenericDialogData } from '../../models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ds-confirm-dialog',
  templateUrl: './ds-confirm-dialog.component.html',
  styleUrls: ['./ds-confirm-dialog.component.scss'],
})
export class DsConfirmDialogComponent {
  /**
   *
   */
  data: BydGenericDialogData = null;

  /**
   * DsConfirmDialogComponent dialog.
   *
   * @param dialogRef MatDialogRef
   * @param data BydGenericDialogData
   * @param translate TranslateService
   */
  constructor(
    public dialogRef: MatDialogRef<DsConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: BydGenericDialogData,
    private translate: TranslateService
  ) {
    if (data) {
      this.data = data;
      this.dialogRef.disableClose = this.data.disableClose;
      if (!this.data.state) {
        this.data.state = 'primary';
      }
    }
  }

  /**
   * Close dialog and return a boolean.
   *
   * @param result result can be either null, true, false.
   */
  close(result = null): void {
    this.dialogRef.close(result);
  }
}
